import React, { useEffect, useState } from 'react';
import '../order.css';
import { Route, useRouteMatch, Redirect } from 'react-router-dom';
import ActiveProducts from './Approved/ActiveProducts';
import OutOfStockProducts from './Approved/OutOfStockProducts';
import ActionRequiredProducts from './Approved/ActionRequiredProducts';
import PriceChangeRequest from './Approved/PriceChangeRequest';
import WeightVerification from './Approved/WeightVerification';
import BlockedProducts from './Approved/Blockedproducts';
import { useSelector } from 'react-redux';
import InventoryTabs from './InventoryTabs';
import AllProducts from './Approved/AllProducts';

function Approved(props) {
    // Records for different orders status
    const [allRec, setAllRec] = useState(0);
    const [activeRec, setActiveRec] = useState(0);
    const [outOfStockRec, setOutOfStockRec] = useState(0);
    const [actionRequired, setActionRRequired] = useState(0);
    const [weightVerificationCnt, setWeightVerificationCnt] = useState(0);
    const [blockedProductsRec, setBlockedProductsRec] = useState(0);
    const { path } = useRouteMatch();
    const inventoryCount = useSelector((state) => state?.ActionReducer?.inventoryCount);

    // Parent (`Inventry.js`) is the single source of count APIs.
    // Child (`Approved.js`) only consumes Redux counts to avoid duplicate requests.
    useEffect(() => {
        setAllRec(inventoryCount?.allProducts || 0);
        setActiveRec(inventoryCount?.activeProducts || 0);
        setOutOfStockRec(inventoryCount?.outofstock || 0);
        setActionRRequired(inventoryCount?.actionRequired || 0);
        setWeightVerificationCnt(inventoryCount?.weightVerification || 0);
        setBlockedProductsRec(inventoryCount?.blockedProducts || 0);
    }, [inventoryCount]);




    return (
        <>
            <div className=''>
                <InventoryTabs
                    allRec={allRec}
                    activeRec={activeRec}
                    actionRequired={actionRequired}
                    weightVerificationCnt={weightVerificationCnt}
                    outOfStockRec={outOfStockRec}
                    blockedProductsRec={blockedProductsRec} // ✅ pass to tabs
                />
            </div>
            <div>
                <Route exact path="/my-inventory/all-products">
                    <Redirect to={`${path}/all`} />
                </Route>
                <Route path={`${path}/all-products`} component={AllProducts} />
                <Route path={`${path}/active`} component={ActiveProducts} />
                <Route path={`${path}/outofstock`} component={OutOfStockProducts} />
                {/* SL-1221 change action required page design */}
                {/* <Route path={`${path}/actionrequired`} component={ActionRequiredProducts} /> */}
                <Route path={`${path}/actionrequired`} component={PriceChangeRequest} />
                
                <Route path={`${path}/weightverification`} component={WeightVerification} />
                <Route path={`${path}/blocked`} component={BlockedProducts} /> {/* ✅ added route */}
            </div>
        </>
    )
}

export default Approved;



